import { useState } from "react";
import { Tabs, Tab, Box, Grid } from "@mui/material";
import Container from "@mui/material/Container";

import PageTitle from "components/PageTitle";
import CreateRequestDialog from "./CreateRequestDialog";
import Ticket from "./Ticket";

const DigitizeArtwork = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [currentTab, setCurrentTab] = useState(0);

  // Sample data - replace with actual data from your backend
  const [requests] = useState([
    {
      id: "12345",
      title: "Artwork Digitization Request",
      description: "Need to digitize a collection of watercolor paintings",
      status: "created",
    },
    {
      id: "12345sd1",
      title: "Artwork Digitization Request",
      description: "Need to digitize a collection of watercolor paintings",
      status: "created",
    },
    {
      id: "12345wewe",
      title: "Artwork Digitization Request",
      description: "Need to digitize a collection of watercolor paintings",
      status: "created",
    },
    {
      id: "12345sd",
      title: "Artwork Digitization Request",
      description: "Need to digitize a collection of watercolor paintings",
      status: "created",
    },

    {
      id: "12sd346",
      title: "Photo Restoration Project",
      description: "Restore and digitize old family photographs",
      status: "in-progress",
    },
    {
      id: "12sd346erersds90",
      title: "Photo Restoration Project",
      description: "Restore and digitize old family photographs",
      status: "in-progress",
    },
    {
      id: "12sd346sdrrtt",
      title: "Photo Restoration Project",
      description: "Restore and digitize old family photographs",
      status: "in-progress",
    },
    {
      id: "12sd3462323",
      title: "Photo Restoration Project",
      description: "Restore and digitize old family photographs",
      status: "in-progress",
    },
    {
      id: "123fsf47",
      title: "Digital Art Conversion",
      description: "Convert traditional sketches to digital format",
      status: "completed",
    },
    {
      id: "1ghfhg2347",
      title: "Digital Art Conversion",
      description: "Convert traditional sketches to digital format",
      status: "completed",
    },
    {
      id: "12347asqwe",
      title: "Digital Art Conversion",
      description: "Convert traditional sketches to digital format",
      status: "completed",
    },
    {
      id: "12347sda",
      title: "Digital Art Conversion",
      description: "Convert traditional sketches to digital format",
      status: "completed",
    },
    {
      id: "12348j2h3j2h3",
      title: "Portrait Digitization",
      description: "Digitize oil painting portraits",
      status: "cancelled",
    },
    {
      id: "12348j2h3j2h3j23",
      title: "Portrait Digitization",
      description: "Digitize oil painting portraits",
      status: "cancelled",
    },
    {
      id: "12348232323jk3hi23",
      title: "Portrait Digitization",
      description: "Digitize oil painting portraits",
      status: "cancelled",
    },
    {
      id: "12348232323jk3wewewehi23",
      title: "Portrait Digitization",
      description: "Digitize oil painting portraits",
      status: "cancelled",
    },
  ]);

  const buttons = [
    {
      label: "Create Request",
      onClick: () => setIsDialogOpen(true),
    },
  ];

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const getFilteredRequests = () => {
    const statusMap = ["created", "in-progress", "completed", "cancelled"];
    return requests.filter(
      (request) => request.status.toLowerCase() === statusMap[currentTab]
    );
  };

  const renderTabContent = () => {
    const filteredRequests = getFilteredRequests();

    if (filteredRequests.length === 0) {
      return (
        <Box sx={{ textAlign: "center", mt: 4, color: "text.secondary" }}>
          No requests found
        </Box>
      );
    }

    return (
      <Box sx={{ mt: 2 }}>
        <Grid container spacing={2}>
          {filteredRequests.map((request) => (
            <Grid item xs={12} sm={6} md={3} key={request.id}>
              <Ticket request={request} />
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  };

  return (
    <Container>
      <PageTitle title="Color Separations Requests" buttons={buttons} />
      <Box sx={{ borderBottom: 1, borderColor: "divider", mt: 3 }}>
        <Tabs value={currentTab} onChange={handleTabChange}>
          <Tab label="Created" />
          <Tab label="In-Progress" />
          <Tab label="Completed" />
          <Tab label="Cancelled" />
        </Tabs>
      </Box>
      <Box sx={{ mt: 3 }}>{renderTabContent()}</Box>
      <CreateRequestDialog
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
      />
    </Container>
  );
};

export default DigitizeArtwork;
